import _ from 'lodash'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { PlatformBuilderDefinition, PlatformBuilderProps } from './PlatformBuilder'
import type { BaseDataItem } from '@wix/thunderbolt-becky-types'

const omitBaseDataItemRecursively = (dataItem: Record<string, BaseDataItem<any>>): any => {
	if (_.isObject(dataItem)) {
		const newDataItem: Record<string, any> = _.omit(dataItem, 'id', 'type')
		for (const key in newDataItem) {
			newDataItem[key] = omitBaseDataItemRecursively(newDataItem[key])
		}
		return newDataItem
	}
	return dataItem
}

export const props = withCompInfo<PlatformBuilderProps, PlatformBuilderDefinition>()(
	// @ts-ignore
	['innerElementsDataOverrides', 'compData'],
	// @ts-ignore
	({ innerElementsDataOverrides, compData }) => {
		const elementProps = omitBaseDataItemRecursively(innerElementsDataOverrides)

		return {
			elementProps,
			wix: compData?.wix,
			...compData?.data,
		}
	}
)
